<template>
  <div></div>
</template>

<script>
import RealTimeMonitorServiceWorker from '../common/ws.worker'
import TitleMarquee from '../common/title-marquee'
import SettingStorage from '../common/setting-storage'

export default {
  name: 'MonitorService',
  props: {},
  data () {
    return {
      realTimeMonitorService: null,
      titleMarquee: null,
      users: []
    }
  },
  created: function () {
    this.initService()
    this.titleMarquee = new TitleMarquee()
    const that = this
    document.addEventListener('click', function () {
      that.titleMarquee.stop('监护系统')
    })
  },
  methods: {
    initService () {
      const that = this
      this.realTimeMonitorService = new RealTimeMonitorServiceWorker()
      this.realTimeMonitorService.onmessage = function (e) {
        // console.log('receive monitor service worker data:: ', e.data)
        if (e.data.cmd) {
          const cmd = e.data.cmd
          if (cmd === 'userList') {
            that.arrangeUsers(e.data.args.users)
            that.$emit('onMessage', {cmd: 'userList'})
          } else if (cmd === 'fhrData') {
            that.addPoints(e.data.args)
            that.$emit('onMessage', {cmd: 'fhrData', args: e.data.args})
          } else if (cmd === 'msgReceipt') {
            const msg = that.receiveMsgReceipt(e.data.args)
            if (msg) {
              e.data.args.newMsg = msg
              that.$emit('onMessage', {cmd: 'msgReceipt', args: e.data.args})
            }
          } else if (cmd === 'msg') {
            const msg = that.receiveMsg(e.data.args)
            if (msg) {
              e.data.args.newMsg = msg
              that.$emit('onMessage', {cmd: 'msg', args: e.data.args})
            }
          } else if (cmd === 'loginSucceed') {
            that.clear()
          } else if (cmd === 'signOut') {
            that.$emit('onMessage', {cmd: 'signOut'})
          } else if (cmd === 'startReissue') {
            that.prepareReceiveReissue(e.data.args)
            that.$emit('onMessage', {cmd: 'startReissue', args: e.data.args})
          } else if (cmd === 'userChange') {
            if (e.data.data.Type === 0) {
              // 【&#127542;有新的实时监护孕妇上线&#128512;】
              that.titleMarquee.init('【🈶有新的实时监护孕妇上线😀】')
            }
            that.playAudio(e.data.data.Type === 0)
            that.showNotice(e.data.data)
          }
        }
      }
      this.realTimeMonitorService.onerror = function (e) {
        console.log([
          'ERROR: Line ', e.lineno, ' in ', e.filename, ': ', e.message
        ].join(''))
      }
    },
    connect (token) {
      this.realTimeMonitorService.postMessage({
        cmd: 'init',
        args: {
          wsUrl: process.env.VUE_APP_REALTIME_MONITOR_URL,
          token: token
        }
      })
    },
    addPoints (args) {
      const userId = args.userId
      const data = JSON.parse(JSON.stringify(args.data))
      const length = this.users.length
      for (let i = 0; i < length; i++) {
        if (this.users[i].userId === userId && this.users[i].userType === args.userType) {
          this.users[i].points = this.users[i].points.concat(data)
          this.checkAlarm(this.users[i], data)
          break
        }
      }
    },
    checkAlarm (user, data) {
      if (!user.alarm) {
        user.alarm = {
          fhr: {
            fhr1: {
              start: 0,
              type: -1
            },
            fhr2: {
              start: 0,
              type: -1
            }
          }
        }
      }
      const params = SettingStorage.get()
      if (params && params.normalRange && params.normalRange.length === 2 && params.alarm && params.alarm.fhrRange) {
        let fhrNormalRange = params.normalRange
        // eslint-disable-next-line one-var
        let i = 0, length = data.length, fhr1 = -1, fhr2 = -1
        // 1、遍历收到的数据包，检查fhr1和fhr2是否持续不正常
        for (i; i < length; i++) {
          const item = data[i]
          if (item.fhr1 > 0) {
            if (item.fhr1 < fhrNormalRange[0]) {
              fhr1 = 0
            } else if (item.fhr1 > fhrNormalRange[1]) {
              fhr1 = 1
            } else {
              fhr1 = -1
            }
          }
          if (item.fhr2 > 0) {
            if (item.fhr2 < fhrNormalRange[0]) {
              fhr2 = 0
            } else if (item.fhr2 > fhrNormalRange[1]) {
              fhr2 = 1
            } else {
              fhr2 = -1
            }
          }

          // // TEST
          // fhr1 = 0
          // fhr2 = 1
        }
        // 2、如果来的数据包没有异常，则暂停报警
        if (user.alarm.fhr.state && fhr1 === -1 && fhr2 === -1) {
          user.alarm.fhr.state = false
        } else {
          // 3、判断是否符合报警条件
          let alarmState = false
          if (fhr1 !== -1) {
            user.alarm.fhr.fhr1.start += length
            user.alarm.fhr.fhr1.type = fhr1
            if ((user.alarm.fhr.fhr1.start / 4) >= 10) {
              alarmState = true
            }
          } else {
            user.alarm.fhr.fhr1.start = 0
            user.alarm.fhr.fhr1.type = -1
          }
          if (fhr2 !== -1) {
            user.alarm.fhr.fhr2.start += length
            user.alarm.fhr.fhr2.type = fhr2
            if ((user.alarm.fhr.fhr2.start / 4) >= 10) {
              alarmState = true
            }
          } else {
            user.alarm.fhr.fhr2.start = 0
            user.alarm.fhr.fhr2.type = -1
          }
          // 4、报警
          user.alarm.fhr.state = alarmState
        }
      } else {
        user.alarm.fhr.state = false
      }
    },
    prepareReceiveReissue (args) {
      const userId = args.userId
      const userType = args.userType
      console.log('reissue::', '收到补发开始请求，准备清空points', userId, userType)
      const length = this.users.length
      for (let i = 0; i < length; i++) {
        if (this.users[i].userId === userId && this.users[i].userType === userType) {
          this.users[i].points = []
          console.log('reissue::', '收到补发开始请求，清空points成功', userId, userType)
          break
        }
      }
      console.log('reissue::', '收到补发开始请求，准备清空points，没有找到用户', userId, userType)
    },
    clear () {
      const length = this.users.length
      for (let i = 0; i < length; i++) {
        this.users[i].points = []
        this.$emit('onMessage', {
          cmd: 'startReissue',
          args: {userId: this.users[i].userId, userType: this.users[i].userType}
        })
      }
    },
    postMessage (params) {
      this.realTimeMonitorService.postMessage(params)
    },
    tocoReset (userId, userType) {
      this.postMessage({cmd: 'tocoReset', args: {userId: userId, userType: userType}})
    },
    sendMsgReceipt (userId, userType, timestamp) {
      this.postMessage({cmd: 'msgReceipt', args: {userId: userId, usertype: userType, timestamp: timestamp}})
    },
    arrangeUsers (users) {
      const localLength = this.users.length
      if (users && users.length > 0) {
        // 如果服务器返回列表不为空，检查本地是否有已经掉线用户
        // 如果有，设置expire
        for (let i = 0; i < localLength; i++) {
          let state = false
          for (let n = 0; n < users.length; n++) {
            if (users[n].userId === this.users[i].userId && users[n].userType === this.users[i].userType) {
              state = true
              break
            }
          }
          if (state) {
            if (this.users[i].expire) {
              this.users[i].expire = 0
            }
          } else {
            this.users[i].expire = new Date().getTime()
          }
        }
        // 将新上线用户添加到本地
        const newUsers = []
        for (let i = 0; i < users.length; i++) {
          const item = users[i]
          item.state = 0
          item.points = []
          item.message = []
          item.unRead = 0
          item.newUnRead = 0
          if (localLength === 0) {
            newUsers.push(item)
          } else {
            let state = false
            for (let n = 0; n < localLength; n++) {
              if (this.users[n].userId === item.userId && this.users[n].userType === item.userType) {
                state = true
                break
              }
            }
            if (!state) {
              newUsers.push(item)
            }
          }
        }
        this.users = this.users.concat(newUsers)
      } else {
        // 所有本地用户都要设置expire时间
        for (let n = 0; n < localLength; n++) {
          this.users[n].expire = new Date().getTime()
        }
      }

      this.checkExpire()
    },
    // 仅保留在线用户
    checkExpire () {
      if (this.users && this.users.length > 0) {
        const newUsers = []
        const localLength = this.users.length
        for (let n = 0; n < localLength; n++) {
          const item = this.users[n]
          if (!item.expire) {
            newUsers.push(item)
            continue
          }
          if (this.users[n].expire === 0) {
            newUsers.push(item)
          }
        }
        this.users = newUsers
      }

      if (this.users.length === 0) {
        this.titleMarquee.stop('监护系统')
      }
    },
    getOnlineUsers () {
      return this.users
    },
    getMessage (userId, userType) {
      if (this.users && this.users.length > 0) {
        const localLength = this.users.length
        for (let n = 0; n < localLength; n++) {
          const item = this.users[n]
          if (item.userId === userId && item.userType === userType) {
            return {msg: item.message, seconds: item.points.length / 4}
          }
        }
      }

      return null
    },
    sendMsg (userId, userType, msg, timestamp) {
      // 消息存入user中，hidden=1
      let state = false
      if (this.users && this.users.length > 0) {
        const localLength = this.users.length
        for (let n = 0; n < localLength; n++) {
          const item = this.users[n]
          if (item.userId === userId && item.userType === userType) {
            item.message.push({
              type: 'text', fromAuthor: 'me', data: {text: msg}, timestamp: timestamp, hidden: 0, sendState: 1
            })
            state = true
            break
          }
        }
      }
      if (state) {
        this.postMessage({cmd: 'msg', args: {userId: userId, userType: userType, msg: msg, timestamp: timestamp}})
      }
    },
    fillMessage (userId, userType, list) {
      if (this.users && this.users.length > 0) {
        const localLength = this.users.length
        for (let n = 0; n < localLength; n++) {
          const item = this.users[n]
          if (item.userId === userId && item.userType === userType) {
            item.message.splice(0, item.message.length)
            for (let m = 0; m < list.length; m++) {
              item.message.push({
                type: 'text',
                fromAuthor: list[m].author,
                data: {text: list[m].content},
                timestamp: list[m].createTime,
                hidden: 0,
                sendState: list[m].sendState ? 2 : 1
              })
            }
            break
          }
        }
      }
    },
    receiveMsgReceipt (args) {
      let msgObj = null

      const userId = args.userId
      const timestamp = args.timestamp
      if (this.users && this.users.length > 0) {
        const localLength = this.users.length
        for (let n = 0; n < localLength; n++) {
          const item = this.users[n]
          if (item.userId === userId && item.userType === args.userType) {
            if (item.message) {
              for (let m = item.message.length - 1; m >= 0; m--) {
                const msg = item.message[m]
                if (msg.timestamp === timestamp) {
                  msg.hidden = 0
                  msg.sendState = 2
                  msgObj = msg
                }
              }
            }
            break
          }
        }
      }

      return msgObj
    },
    receiveMsg (args) {
      let msgObj = null
      if (this.users && this.users.length > 0) {
        const localLength = this.users.length
        for (let n = 0; n < localLength; n++) {
          const item = this.users[n]
          if (item.userId === args.userId && item.userType === args.userType) {
            const msg = {
              type: 'text',
              fromAuthor: item.name,
              data: {text: args.msg},
              timestamp: args.timestamp,
              hidden: 0,
              sendState: 2
            }
            item.message.push(msg)
            item.unRead++
            msgObj = msg
            break
          }
        }
      }
      return msgObj
    },
    clearUnRead (userId, userType) {
      if (this.users && this.users.length > 0) {
        const localLength = this.users.length
        for (let n = 0; n < localLength; n++) {
          const item = this.users[n]
          if (item.userId === userId && item.userType === userType) {
            item.unRead = 0
            break
          }
        }
      }
    },
    receiveNewMsg (userId, userType, unRead) {
      if (this.users && this.users.length > 0) {
        const localLength = this.users.length
        for (let n = 0; n < localLength; n++) {
          const item = this.users[n]
          if (item.userId === userId && item.userType === userType) {
            item.newUnRead = unRead
            return true
          }
        }
      }
      return false
    },
    clearNewUnRead (userId, userType) {
      if (this.users && this.users.length > 0) {
        const localLength = this.users.length
        for (let n = 0; n < localLength; n++) {
          const item = this.users[n]
          if (item.userId === userId && item.userType === userType) {
            item.newUnRead = 0
            break
          }
        }
      }
    },
    existUnReadMessage () {
      if (this.users && this.users.length > 0) {
        const localLength = this.users.length
        for (let n = 0; n < localLength; n++) {
          const item = this.users[n]
          if (item.newUnRead && item.newUnRead > 0) {
            return true
          }
        }
      }
      return false
    },
    showNotice (data) {
      if (window.Notification) {
        console.log('notify::', 'show notify1.', Notification.permission)
        if (Notification.permission === 'granted') {
          console.log('notify::', 'show notify2.')
          this.notice(data)
        } else if (Notification.permission !== 'denied') {
          Notification.requestPermission(function (permission) {
            console.log('notify::', 'show notify3.')
            this.notice(data)
          })
        } else {
          console.log('notify::', 'show notify4.')
        }
      } else {
        console.log('notify::', 'show notify11.')
      }
    },
    notice (data) {
      if (Notification.permission === 'granted') {
        console.log('notify::', 'show notify5.')
        const notification = new Notification(data.Type === 0 ? '有新用户上线' : '有用户下线', {
          body: '孕妇' + data.UserInfo.Name + '' + (data.Type === 0 ? '上线。' : '下线。'),
          icon: '',
          requireInteraction: true
        })

        notification.onclick = function () {
          notification.close()
        }
      } else {
        console.log('notify::', 'show notify6.')
      }
    },
    playAudio (state) {
      if (window._isInElectron) {
        window._sendToElectron('user-audio', {
          cmd: state ? 'online' : 'offline'
        })
      }
    }
  },
  destroyed () {
    if (this.realTimeMonitorService) {
      this.realTimeMonitorService.postMessage({cmd: 'close'})
      this.realTimeMonitorService.terminate()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
